import {useSelector} from 'react-redux'
import {getUrlParams} from 'modules/meta/selectors'

/** @deprecated use `getUrlParams` selector directly */
const useParams = () => useSelector(getUrlParams)

export default useParams
